export default __webpack_public_path__ + "static/media/galore.b2fe0d6d.webp";